import _slicedToArray from "/home/runner/_work/dataschoolv2/dataschoolv2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useMemo as o, useReducer as h } from "react";
import { useIsoMorphicEffect as s } from './use-iso-morphic-effect.js';
function f(e) {
  if (e === null) return {
    width: 0,
    height: 0
  };
  var _e$getBoundingClientR = e.getBoundingClientRect(),
    t = _e$getBoundingClientR.width,
    r = _e$getBoundingClientR.height;
  return {
    width: t,
    height: r
  };
}
function d(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  var _h = h(function () {
      return {};
    }, {}),
    _h2 = _slicedToArray(_h, 2),
    r = _h2[0],
    u = _h2[1],
    i = o(function () {
      return f(e);
    }, [e, r]);
  return s(function () {
    if (!e) return;
    var n = new ResizeObserver(u);
    return n.observe(e), function () {
      n.disconnect();
    };
  }, [e]), t ? {
    width: "".concat(i.width, "px"),
    height: "".concat(i.height, "px")
  } : i;
}
export { d as useElementSize };